import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DotsHorizontalGlyph = /*#__PURE__*/createElement("g", {
  id: "dots_horizontal"
}, /*#__PURE__*/createElement("circle", {
  cx: "21.1",
  cy: "42",
  r: "5.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "5.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "62.9",
  cy: "42",
  r: "5.7"
}));
const DotsHorizontal = createSvg({
  name: 'dots_horizontal',
  path: DotsHorizontalGlyph
});

export default DotsHorizontal;
export { DotsHorizontalGlyph };
